module.exports = __webpack_public_path__ + "img/front neck drop.4c93064a.png";